<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { fontBase, fontHeadings, logoUrl } from '@client/stores/brand';

  import Layout from './layout.svelte';

  const navigate = useNavigate();

  export let show = false;

  let uploading = false;

  const onSelect = async (template) => {
    navigate(`new/${template.id}`);
  };

  const toggle = () => {
    show = false;
  };
</script>

{#if show}
  <Modal class="modal-wizard" isOpen size="xl" fullscreen="lg" {...$$restProps}>
    <ModalHeader class="text-center" {toggle}>{$format('label.BIZCARD_NEW_CARD_MODAL_HEADER')}</ModalHeader>

    <ModalBody style="min-height: 33vh; margin-bottom: 72px;">
      <Layout {onSelect} />
    </ModalBody>
  </Modal>
{/if}
